import { LOAN_CATEGORIES } from 'Common/constants/loanCategories';
import { MODAL_SECTION } from 'Common/constants/generateReports';

export default class MultiLoanCpaModalCtrl {
  constructor($state, contactService, loanAppSharedData, $uibModal) {
    'ngInject';

    this.$state = $state;
    this.contactService = contactService;
    this.loanAppSharedData = loanAppSharedData;
    this.$uibModal = $uibModal;
  }

  $onInit() {
    this.maxLoansDownloable = 3;

    const familyId = this.$state.params.familyId;
    this.contactService.loanListGet(familyId, false).then(({ data }) => {
      if (!data) {
        return;
      }

      const inprogressLoans =
        data.filter(
          (loan) =>
            loan.LoanStatus.LoanStatusCategory === LOAN_CATEGORIES.INPROGRESS,
        ) || [];

      inprogressLoans.map((loan) => {
        if (loan.Lender) {
          loan.Lender = {
            ...loan.Lender,
            LenderId: loan.Lender.LenderId
              ? parseInt(loan.Lender.LenderId, 10)
              : 0,
          };
        }
        loan.LoanPurpose = loan.LoanPurpose ? loan.LoanPurpose.split(',') : '';
        return loan;
      });

      this.inprogressLoans = this.loanAppSharedData.distinguishPartyForLendingTab(
        inprogressLoans,
      );
    });
  }

  selectLoan(loanScenarioId) {
    const selectedLoans = this.inprogressLoans.reduce((accum, current) => {
      if (current.LoanScenarioID === loanScenarioId) {
        const tickedLoan = {
          ...current,
          isTicked: !current.isTicked,
        };
        return tickedLoan.isTicked ? accum.concat(tickedLoan) : accum;
      }
      if (current.isTicked) {
        return accum.concat(current);
      }
      return accum;
    }, []);
    this.multiLoanCpaIds = selectedLoans.map((elem) => elem.LoanScenarioID);
  }

  nextStep() {
    if (!this.multiLoanCpaIds || !this.multiLoanCpaIds.length) {
      return;
    }

    this.$uibModal.open({
      templateUrl:
        '/assets/views/loanApplication/sidebar/modal/recommendationReport.html',
      controller: 'RecommendationModalCtrl',
      windowClass: 'mc-recommendation-report-modal',
      size: 'md',
      resolve: {
        multiLoanCpaIds: () => this.multiLoanCpaIds,
        activeModalSection: () => MODAL_SECTION.CPA,
        eSignSubscription: () => false,
        loanAppId: 0,
      },
    });
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }
}
